export default __webpack_public_path__ + "static/media/dsg.5fc96477.svg";